/* SUPRA Hero Carousel — progressive enhancement, a11y-first */
(function () {
  'use strict';

  function initHero(root) {
    const slides = Array.from(root.querySelectorAll('.supra-hero__slide'));
    if (slides.length < 2) return;

    const dots = Array.from(root.querySelectorAll('[data-supra-hero-dot]'));
    const prevBtn = root.querySelector('[data-supra-hero-prev]');
    const nextBtn = root.querySelector('[data-supra-hero-next]');
    const progress = root.querySelector('[data-supra-hero-progress]');

    // Autoplay duration — read from data attr or default 6s
    const autoplaySeconds = parseInt(root.getAttribute('data-autoplay') || '6', 10);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = reduceMotion ? 0 : autoplaySeconds * 1000;

    let current = slides.findIndex(s => s.getAttribute('data-active') === 'true');
    if (current < 0) current = 0;

    let progressStart = null;
    let progressFrame = null;
    let rotateTimer = null;
    let paused = false;

    function go(to, opts) {
      opts = opts || {};
      const next = (to + slides.length) % slides.length;
      if (next === current) return;
      slides[current].setAttribute('data-active', 'false');
      slides[current].removeAttribute('data-active');
      slides[next].setAttribute('data-active', 'true');

      dots.forEach((d, i) => {
        if (i === next) d.setAttribute('aria-selected', 'true');
        else d.removeAttribute('aria-selected');
      });

      current = next;
      if (!opts.silent) restart();
    }

    function start() {
      if (!duration || paused) return;
      progressStart = performance.now();
      tick();
      rotateTimer = window.setTimeout(() => go(current + 1), duration);
    }

    function stop() {
      if (rotateTimer) { clearTimeout(rotateTimer); rotateTimer = null; }
      if (progressFrame) { cancelAnimationFrame(progressFrame); progressFrame = null; }
      if (progress) progress.style.width = '0';
    }

    function restart() { stop(); start(); }

    function tick() {
      if (!progress || !duration) return;
      const t = Math.min(1, (performance.now() - progressStart) / duration);
      progress.style.width = (t * 100).toFixed(2) + '%';
      if (t < 1) progressFrame = requestAnimationFrame(tick);
    }

    // Controls
    if (prevBtn) prevBtn.addEventListener('click', () => go(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => go(current + 1));
    dots.forEach(d => d.addEventListener('click', () => {
      const i = parseInt(d.getAttribute('data-supra-hero-dot'), 10);
      go(i);
    }));

    // Pause on hover (desktop) / focus
    root.addEventListener('mouseenter', () => { paused = true;  stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin',   () => { paused = true;  stop(); });
    root.addEventListener('focusout',  () => { paused = false; start(); });

    // Pause when out of viewport
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) { paused = false; start(); }
          else { paused = true; stop(); }
        });
      }, { threshold: 0.1 });
      io.observe(root);
    }

    // Pause on tab hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { paused = true; stop(); }
      else { paused = false; start(); }
    });

    // Swipe / keyboard
    let touchStartX = 0;
    root.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) go(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  go(current - 1);
      if (e.key === 'ArrowRight') go(current + 1);
    });

    start();
  }

  function boot() {
    document.querySelectorAll('[data-supra-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor compatibility
  document.addEventListener('shopify:section:load', boot);
})();
